import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface TokenLimitUpdateProps {
  tokenApprovalLimit: number;
}

export const useUpdateTokenLimit = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateTokenLimit = async (data: TokenLimitUpdateProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/org/token-limit`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to update token limit');
    }
  };

  return useMutation({
    mutationFn: updateTokenLimit,
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.OrganisationById]);
    },
  });
};
